import React from 'react';

import cn from 'classnames';

import styles from './TextArea.module.css';
import { useOrionUID } from '../../helpers/orionUID';
import { Description } from '../description/Description';
import { Label } from '../label/Label';
import { Message } from '../message/Message';

type TextAreaProps = {
  label?: string;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  description?: string;
  descriptionProps?: React.HTMLAttributes<HTMLSpanElement>;
  error?: string;
  success?: string;
  wrapperClassName?: string;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      className,
      disabled,
      label,
      labelProps,
      description,
      descriptionProps,
      error,
      success,
      wrapperClassName,
      ...textAreaProps
    },
    ref,
  ) => {
    const orionUID = useOrionUID();

    return (
      <div className={cn(styles.formElementWrapper, wrapperClassName)}>
        {label && (
          <Label htmlFor={textAreaProps.id || orionUID} {...labelProps}>
            {label}
          </Label>
        )}
        {description && (
          <Description
            className={styles.description}
            description={description}
            id={`${textAreaProps.id || orionUID}_desc`}
            {...descriptionProps}
          />
        )}

        <textarea
          className={cn(styles.textArea, className, {
            [styles.topMargin]: !!label || !!description,
          })}
          ref={ref}
          disabled={disabled}
          aria-describedby={`${textAreaProps.id || orionUID}_desc`}
          id={orionUID}
          {...textAreaProps}
        />

        <div className={styles.status}>
          {error && <Message message={error} type="error" />}
          {success && <Message message={success} type="success" />}
        </div>
      </div>
    );
  },
);

TextArea.displayName = 'TextArea';
